import { themeConfig } from '@make-software/cspr-design';

export const appThemeConfig = {
  ...themeConfig,
  styleguideColors: {
    backgroundPrimary: '#161D3B',
    backgroundSecondary: '#0F1429',
    backgroundTertiary: '#131933',
    backgroundQuaternary: '#0F1429',
    borderPrimary: '#1A2347',
    borderSecondary: '#5C6073',
    borderRed: '#FF8680',
    fillPrimaryRed: '#B2332D',
    fillPrimaryRedHover: '#932F30',
    fillPrimaryRedClick: '#742A33',
    fillPrimaryBlue: '#294ACC',
    fillPrimaryBlueHover: '#112A8C',
    fillPrimaryBlueClick: '#14266D',
    fillSecondary: '#1B254A',
    fillSecondaryRedHover: '#FF868029',
    fillSecondaryRedClick: '#FF868014',
    fillSecondaryBlueHover: '#7490FF29',
    fillSecondaryBlueClick: '#7490FF14',
    fillTertriary: '#293667',
    fillGreen: '#2DCC85',
    fillVioletGradient: 'linear-gradient(266.5deg, #A880FF 9.3%, #8B5BF1 94.39%)',
    fillBlueGradient: 'linear-gradient(89.56deg, #0021A5 0%, #2C53EF 75.01%)',
    fillLoadingInTable: 'linear-gradient(90deg, #1B254A 43.6%, rgba(22, 29, 59, 0) 100%)',
    contentPrimary: '#DADCE5',
    contentSecondary: '#A8ADBF',
    contentTertiary: '#989DB2',
    contentQuaternary: '#8D92A6',
    contentOnFill: '#F2F2F2',
    contentBlue: '#8FA6FF',
    contentRed: '#FF8680',
    contentGreen: '#4CD99A',
    contentGreenLight: '#4CD99A1F',
    contentViolet: '#A880FF',
    contentYellow: '#E0BB38',
    contentWarmGreen: '#BDD94C',
    contentLightBlue: '#8FA6FF'
  }
};
